var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowIconDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.82 8.827a.604.604 0 000-.86l-3.463-3.47L8.82 1.034a.606.606 0 00-.852-.859l-3.47 3.47L1.034.175a.614.614 0 00-.859 0 .615.615 0 000 .86l3.463 3.462-3.463 3.47a.615.615 0 000 .86c.23.236.622.23.86 0l3.462-3.47 3.47 3.47c.23.23.623.236.853 0z"
  })));
}
export default SvgFollowIconDelete;